import { useState } from "react";
import CustomTabs from "shared/components/common/customTabs";
import classNames from "classnames";
import styles from "./style.module.scss";
import TermsAndConditions from "../../../shared/components/dashboard/termsAndConditions";
import PrivacyPolicy from "../../../shared/components/dashboard/privacyPolicy";
import CookiesPolicy from "../../../shared/components/dashboard/cookiesPolicy";

const DashboardPolicies = () => {
  const [activeTab, setActiveTab] = useState<string>("terms");

  const tabs = [
    { label: "Terms and Conditions", value: "terms" },
    { label: "Privacy Policy", value: "privacy" },
    { label: "Cookies", value: "cookies" },
  ];

  const handleTabChange = (tabValue: string) => {
    setActiveTab(tabValue);
  };

  return (
    <>
      <div className={classNames(styles.sectionContainer)}>
        <div>
          <CustomTabs
            tabs={tabs}
            fullWidthTabs
            defaultActiveTab="terms"
            onTabChange={handleTabChange}
          />
        </div>
      </div>
      <div className={classNames(styles.sectionContainer, "mt-4")}>
        <div>
          {activeTab === "terms" ? (
            <TermsAndConditions />
          ) : activeTab === "privacy" ? (
            <PrivacyPolicy />
          ) : (
            <CookiesPolicy />
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardPolicies;
